import AssetTokenConfig from 'umg-ember-backend/components/record-explorer/for/asset-token-config';

<template>
  <AssetTokenConfig @records={{@model}} @recordType='asset-token-config' />
</template>
